"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("../utils");
var Mileage = /** @class */ (function (_super) {
    __extends(Mileage, _super);
    function Mileage(props) {
        var _this = _super.call(this, props) || this;
        _this.calculationsPtr = 0;
        _this.regex = /^[0-9\s]*$/;
        _this.toggleIsOpened = _this.toggleIsOpened.bind(_this);
        _this.changeMileage = _this.changeMileage.bind(_this);
        _this.onKeyPress = _this.onKeyPress.bind(_this);
        return _this;
    }
    Mileage.prototype.onKeyPress = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            clearTimeout(this.calculationsPtr);
            this.props.calculate();
        }
    };
    Mileage.prototype.changeMileage = function (_a) {
        var _this = this;
        var value = _a.target.value;
        if (!this.regex.test(value)) {
            return;
        }
        if (this.calculationsPtr) {
            clearTimeout(this.calculationsPtr);
        }
        var parsed = parseInt(value);
        if (parsed <= 0 || Number.isNaN(parsed)) {
            parsed = undefined;
        }
        else if (parsed > 500000) {
            parsed = 500000;
        }
        this.props.change(parsed, function () {
            _this.calculationsPtr = setTimeout(function () {
                _this.props.calculate();
            }, 700);
        });
    };
    Mileage.prototype.toggleIsOpened = function () {
        this.props.toggle();
    };
    Mileage.prototype.render = function () {
        var _a = this.props, value = _a.value, isVisible = _a.isVisible, isOpened = _a.isOpened;
        if (!isVisible) {
            return null;
        }
        return (React.createElement("div", { className: "tradein-estimate__collapse-item " + (isOpened ? 'tradein-estimate__collapse-item_opened' : '') },
            React.createElement("div", { className: "tradein-estimate__collapse-header", onClick: this.toggleIsOpened },
                React.createElement("div", { className: "tradein-estimate__collapse-title" }, "\u041F\u0440\u043E\u0431\u0435\u0433"),
                React.createElement("div", { className: "tradein-estimate__collapse-value" },
                    utils_1.formatPrice(value || 0),
                    " \u043A\u043C.")),
            React.createElement("div", { className: "tradein-estimate__collapse-body" },
                React.createElement("div", { className: "tradein-estimate__input" },
                    React.createElement("input", { onKeyPress: this.onKeyPress, onChange: this.changeMileage, value: value || '', type: "text", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0440\u043E\u0431\u0435\u0433" })))));
    };
    return Mileage;
}(React.PureComponent));
exports.default = Mileage;
